<template>
  <div
    class="modal modal-bottom fade"
    id="topup_completed_modal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="topup_completed_title"
    style="z-index: 10000"
  >
    <div class="modal-dialog" role="document">
      <!-- MBR058 Heritage Hearth success sheet (no design reference: follows the Exchange / Terms sheets) -->
      <div class="modal-content mbr-topup-done">
        <span class="mbr-topup-done__handle" aria-hidden="true"></span>
        <button
          type="button"
          class="btn-close mbr-topup-done__close"
          data-bs-dismiss="modal"
          :aria-label="$t('common.close')"
        >
          <svg fill="none" stroke="currentColor" stroke-width="2.2" viewBox="0 0 24 24" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" /></svg>
        </button>
        <div class="modal-body mbr-topup-done__body">
          <span class="mbr-topup-done__icon" aria-hidden="true">
            <svg fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12" /></svg>
          </span>
          <span class="mbr-topup-done__eyebrow">{{ $t('topup.success') }}</span>
          <h2 id="topup_completed_title" class="mbr-topup-done__title">
            {{
              $t('topup.you_have_paid', {
                amount: '$ ' + new Intl.NumberFormat("en", {
                  maximumFractionDigits: 2,
                  minimumFractionDigits: 2,
                }).format(amount),
              })
            }}
          </h2>
          <!-- plain <button>: <material-button> was never registered here and rendered as an unknown tag -->
          <button type="button" class="mbr-topup-done__cta" @click="processDone">
            {{ $t('common.done') }}
          </button>
        </div>
      </div>
      <button
        class="btn-topup_completed_modal d-none"
        data-bs-toggle="modal"
        data-bs-target="#topup_completed_modal"
      >
        {{ $t('common.done') }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "TopupCompleted",
  props: {
    amount: {
      type: String,
      required: true,
    },
    processDone: {
      type: Function,
      default: () => {},
    },
  },
};
</script>
<style scoped>
/* Bottom sheet mechanics (the only modal variant this component uses) */
.modal.modal-bottom .modal-dialog {
  position: fixed;
  width: 100%;
  max-width: 100%;
  height: auto;
  margin: auto;
  transform: translate3d(0%, 0, 0);
}

.modal.modal-bottom.fade .modal-dialog {
  bottom: -100%;
  transition: opacity 0.3s linear, bottom 0.3s ease-out;
}

.modal.modal-bottom.fade.show .modal-dialog {
  bottom: 0;
}

/* MBR058 Heritage Hearth sheet */
.modal.modal-bottom .modal-content.mbr-topup-done {
  position: relative;
  max-width: 440px;
  height: auto;
  margin: 0 auto;
  overflow-y: auto;
  background: var(--mbr-color-surface);
  border: none;
  border-radius: 32px 32px 0 0;
  box-shadow: var(--mbr-shadow-modal);
  font-family: var(--mbr-font-body);
  color: var(--mbr-color-ink-headline);
}

.mbr-topup-done :where(:not(.material-icons-round)) {
  font-family: var(--mbr-font-body);
}

.mbr-topup-done__handle {
  display: block;
  width: 40px;
  height: 4px;
  margin: 12px auto 0;
  border-radius: var(--mbr-radius-full);
  background: var(--mbr-color-outline);
}

.btn-close.mbr-topup-done__close {
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  padding: 0;
  background: var(--mbr-color-tint) !important;
  border: 0;
  border-radius: var(--mbr-radius-full);
  box-shadow: none;
  opacity: 1;
  color: var(--mbr-color-ink-headline) !important;
}

.mbr-topup-done__close svg {
  width: 20px;
  height: 20px;
}

.modal.modal-bottom .modal-body.mbr-topup-done__body {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 36px 24px calc(32px + env(safe-area-inset-bottom));
  text-align: center;
}

.mbr-topup-done__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  margin-bottom: 16px;
  border-radius: var(--mbr-radius-full);
  background: var(--mbr-color-peach);
  color: var(--mbr-color-primary);
}

.mbr-topup-done__icon svg {
  width: 30px;
  height: 30px;
}

.mbr-topup-done__eyebrow {
  font-size: 11px;
  font-weight: 700;
  line-height: 14px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--mbr-color-ink-secondary);
}

/* font-family/color set explicitly: Material Dashboard forces Roboto Slab on h1-h3 */
.mbr-topup-done__title {
  margin: 6px 0 24px;
  font-family: var(--mbr-font-headline) !important;
  font-size: 22px;
  font-weight: 800;
  line-height: 28px;
  letter-spacing: -0.015em;
  color: var(--mbr-color-ink-strong);
}

.mbr-topup-done__cta {
  width: 100%;
  height: 52px;
  border: 0;
  border-radius: var(--mbr-radius-full);
  background: var(--mbr-color-primary);
  box-shadow: 0 8px 20px -4px rgba(var(--mbr-color-primary-rgb), 0.35);
  font-family: var(--mbr-font-headline) !important;
  font-size: 15px;
  font-weight: 700;
  color: var(--mbr-color-on-primary);
  transition: transform 0.15s ease, background-color 0.15s ease;
}

.mbr-topup-done__cta:hover {
  background: var(--mbr-color-primary-light);
}

.mbr-topup-done__cta:active {
  transform: scale(0.97);
}

.mbr-topup-done__cta:focus-visible,
.mbr-topup-done__close:focus-visible {
  outline: 2px solid var(--mbr-color-primary);
  outline-offset: 2px;
}
</style>
